import React from "react";
import { Box } from "@mui/material";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import EditIcon from "@mui/icons-material/Edit";
import { BorderedStack } from "../../../styled/pos/superficies";
import { useDispatch, useSelector } from "react-redux";
import AddressForm from "./AddressForm";
import {
  setAddress,
  setShowAddressForm,
} from "../../../../store/actions/newOrderSlice";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";

import { formatFinance } from "../../../../utils/formatters";

const AddressCard = () => {
  const dispatch = useDispatch();

  const deliveryCenter = useSelector(
    (state) => state.deliveryCenter.deliveryCenter
  );

  const address = useSelector((state) => state.newOrder.address);
  const showAddressForm = useSelector(
    (state) => state.newOrder.showAddressForm
  );

  // Function to validate address completeness
  const isAddressValid = (addr) => {
    if (!addr) return false;

    // Check for required fields
    const hasRequiredFields =
      addr.street && addr.cep && addr.neighborhood && addr.house_number;

    // Additional check for latitude and longitude
    const hasCoordinates =
      addr.lat !== undefined &&
      addr.lat !== null &&
      addr.lat !== "" &&
      addr.long !== undefined &&
      addr.long !== null &&
      addr.long !== "";

    return hasRequiredFields && hasCoordinates;
  };

  const handleChangeAddress = () => {
    dispatch(setShowAddressForm(!showAddressForm));
  };

  const handleSetAddress = (newAddress) => {
    if (isAddressValid(newAddress)) {
      dispatch(setAddress(newAddress));
    } else {
      alert(
        "Endereço incompleto. Verifique se todos os campos obrigatórios estão preenchidos e se as coordenadas foram calculadas."
      );
    }
  };

  return (
    <BorderedStack>
      <Box
        sx={{
          pt: 1,
          mb: 1,
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        {address && (
          <Chip
            icon={<DeliveryDiningIcon />}
            label={`${formatFinance(address.fee)}`}
            sx={{ ml: 2 }}
          />
        )}
        {!showAddressForm && (
          <Chip
            icon={<EditIcon />}
            label={address ? "Editar Endereço" : "Cadastrar Endereço"}
            onClick={handleChangeAddress}
            sx={{ ml: 2, mr: 2 }}
          />
        )}
      </Box>

      {!showAddressForm && address && (
        <Box sx={{ display: "flex", justifyContent: "start" }}>
          <Stack sx={{ ml: 2 }}>
            <Typography variant="caption">Rua:</Typography>
            <Typography variant="body1" gutterBottom>
              {address.street}
            </Typography>

            <Typography variant="caption">Bairro:</Typography>
            <Typography variant="body1" gutterBottom>
              {address.neighborhood}
            </Typography>

            <Typography variant="caption">Número:</Typography>
            <Typography variant="body1" gutterBottom>
              {address.house_number}
            </Typography>

            {address.address_complement && (
              <>
                <Typography variant="caption">Complemento:</Typography>
                <Typography variant="body1" gutterBottom>
                  {address.address_complement}
                </Typography>
              </>
            )}

            {address.address_reference && (
              <>
                <Typography variant="caption">Referência:</Typography>
                <Typography variant="body1" gutterBottom>
                  {address.address_reference}
                </Typography>
              </>
            )}
          </Stack>
        </Box>
      )}

      {showAddressForm && (
        <AddressForm
          address={address}
          isEditing={!!address}
          setAddress={handleSetAddress}
          deliveryCenterLat={deliveryCenter.lat}
          deliveryCenterLng={deliveryCenter.lng}
        />
      )}
    </BorderedStack>
  );
};

export default AddressCard;
